import * as actionTypes from "./actionTypes";
const initialState = {
  orderMarkingMap: {},
  orderMarkingSource: {},
};

export const actions = {
  addOrderMarking: (orderId, value, source = "button") => ({
    type: actionTypes.ADD_ORDER_MARKING,
    payload: { orderId, value, source },
  }),

  removeOrderMarking: (orderId) => ({
    type: actionTypes.REMOVE_ORDER_MARKING,
    payload: orderId,
  }),
  addBulkOrdersMarking: (orderMap, source) => ({
    type: actionTypes.ADD_BULK_ORDER_MARKING,
    payload: { orderMap, source },
  }),
  clearOrderMarking: () => ({
    type: actionTypes.CLEAR_ORDER_MARKING,
  }),
};

export const myTaskReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_ORDER_MARKING: {
      const { orderId, value, source } = action.payload;
      // Don't override if current source is button and new source is api
      if (
        state.orderMarkingSource[orderId] === "button" &&
        source === "api" &&
        value.key !== "ALL_ISSUES"
      ) {
        return state;
      }
      return {
        ...state,
        orderMarkingMap: {
          ...state.orderMarkingMap,
          [orderId]: value,
        },
        orderMarkingSource: {
          ...state.orderMarkingSource,
          [orderId]: source,
        },
      };
    }

    case actionTypes.REMOVE_ORDER_MARKING: {
      const { [action.payload]: _, ...restMarkings } = state.orderMarkingMap;
      const { [action.payload]: __, ...restSources } = state.orderMarkingSource;
      return {
        ...state,
        orderMarkingMap: restMarkings,
        orderMarkingSource: restSources,
      };
    }

    case actionTypes.ADD_BULK_ORDER_MARKING: {
      const { orderMap, source } = action.payload;
      const newOrderMarkingMap = { ...state.orderMarkingMap };
      const newOrderMarkingSource = { ...state.orderMarkingSource };

      Object.entries(orderMap).forEach(([orderId, value]) => {
        // Only update if the order wasn't previously marked by button
        if (state.orderMarkingSource[orderId] !== "button") {
          newOrderMarkingMap[orderId] = value;
          newOrderMarkingSource[orderId] = source || "api";
        }
      });

      return {
        ...state,
        orderMarkingMap: newOrderMarkingMap,
        orderMarkingSource: newOrderMarkingSource,
      };
    }

    case actionTypes.CLEAR_ORDER_MARKING:
      return {
        ...state,
        orderMarkingMap: {},
        orderMarkingSource: {},
      };

    default:
      return state;
  }
};

myTaskReducer.initialState = initialState;

export default myTaskReducer;
